import ApiEventService from '../services/api-event-service';
export class ApiEventServiceEventTarget {
    constructor(eventSource) {
        eventSource.on('event', (event) => {
            ApiEventService.deliverEvent(event);
        });
    }
}
